module.exports = __webpack_public_path__ + "static/media/09_profile_picture.8f63bdb0.png";